import React__default from 'react';
import keycode from 'keycode';

var getNextIndexFromKeycode = function getNextIndexFromKeycode(keyCode, length, index, direction) {
  if (direction === void 0) {
    direction = 'vertical';
  }

  var previousKey = direction === 'horizontal' ? 'left' : 'up';
  var nextKey = direction === 'horizontal' ? 'right' : 'down';

  switch (keyCode) {
    case keycode(previousKey):
      return index !== undefined ? index - 1 < 0 ? 0 : index - 1 : index;

    case keycode(nextKey):
      return index !== undefined ? index + 1 >= length ? index : index + 1 : index;

    case keycode('home'):
      return 0;

    case keycode('end'):
      return length - 1;

    default:
      return;
  }
};
var useListKeyboardNavigation = function useListKeyboardNavigation(length, options) {
  if (length === void 0) {
    length = 0;
  }

  if (options === void 0) {
    options = {
      direction: 'vertical'
    };
  }

  var _React$useState = React__default.useState(options.initialIndex),
      index = _React$useState[0],
      setIndex = _React$useState[1];

  var getNextIndex = function getNextIndex(event) {
    var nextIndex = getNextIndexFromKeycode(event.keyCode, length, index, options.direction);

    if (nextIndex !== undefined) {
      event.preventDefault();
    }

    return nextIndex;
  };

  return [index, setIndex, getNextIndex];
};

export { getNextIndexFromKeycode, useListKeyboardNavigation };
//# sourceMappingURL=useListKeyboardNavigation.js.map
